<template />

<script>
import Parse from 'parse'
import ParseFunctions from '@/components/ParseFunctions'
import { isMobile } from 'mobile-device-detect'
import Constants from '../components/Constants'

export default {
  mixins: [ParseFunctions, Constants],
  data() {
    return {
      confirmStatus: null,
    }
  },
  async created() {
    let res
    let query = this.$route.query
    switch (this.$route.query.action) {
    case 'change-email':
      res = await this.changeEmail(this.$route.query.email, this.$route.query.token)
      // console.log('changeEmail res', res)
      res = await this.parseLogout()
      // console.log('logout res', res)
      await this.$router.push({ path: '/login', query: { msg: 'email-changed' } })
      break
    case 'register':
      // console.log('confirming registration')
      res = await this.confirmMail(query.email, query.token)
      if (res.status !== 'ok') {
        this.showServerError(res)
        return
      }

      if (isMobile) {
        window.location = 'clavoapp://ConfirmEmail/' + this.$route.query
      }

      res = await this.getTokenDetails(query.token, query['team-invitation-url-token'])
      if (res.status !== 'ok') {
        this.showServerError(res)
        return
      }

      if (res.userStatus === 'confirmed') {
        if (query['team-invitation-url-token']) {
          query.action = 'magic-link'
          query.token = query['team-invitation-url-token']
          await this.$router.push({
            path: '/login',
            query,
          })
          this.showMessage('youNeedToLoginToJoinTeam')
        } else {
          // try {
          //   await Parse.User.logInWith('ClavoTokenAuth', {authData: {id: this.$route.query.token}})
          //   await this.$router.push('/')
          //   this.showMessage('userAlreadyExistPleaseLogin')
          // } catch (e) {
          //   await this.$router.push('/')
          //   this.showError('linkHasExpired')
          // }
          await this.$router.push('/login')
          this.showMessage('userAlreadyExistsPleaseLogin')
        }
      } else {
        await this.$router.push({
          path: '/register',
          query,
        })
      }
      break
    case 'register-from-link':
      // console.log('confirming registration')
      res = await this.confirmMail(this.$route.query.email, this.$route.query.token)
      if (res.status !== 'ok') {
        this.showServerError(res)
        return
      }

      await this.$router.push({
        path: '/register',
        query: {
          action: 'register-from-link',
          token: this.$route.query.token,
          'invitation-token': this.$route.query['invitation-token'],
          email: this.$route.query.email,
        },
      })
      break
    default:
      console.error('Erroneous confirm email link.')
    }
    // } else {
    //         // console.log('confirming registration no purpose given')
    //         try {
    //             res = await Parse.Cloud.run('confirmMail',
    //                 {
    //                     email: this.$route.params.email,
    //                     token: this.$route.params.token
    //                 }, {})
    //         } catch (e) {
    //             console.error('confirming mail e', e)
    //         }
    //     }

    // if (res.status === 'ok') {
    //         if (res.userExists) {
    //             /!*await Parse.User.logInWith('ClavoTokenAuth',
    //                 {authData: {id: this.$route.params.token}})*!/
    //             //this.$router.push('/login') // przekazac info ze jest juz konto na tym mailu
    //         } else if (this.$route.query.action === 'change-email') {
    //             await this.$router.push({path: '/', query: {msg: 'email-changed'}})
    //         } else {
    //             this.$router.push('/register/create-account/' + this.$route.params.token + '/' + this.$route.params.email)
    //         }
    //     }
  },
}
</script>
